import { render, staticRenderFns } from "./imPopup.vue?vue&type=template&id=1a6830ea&scoped=true"
import script from "./imPopup.vue?vue&type=script&lang=js"
export * from "./imPopup.vue?vue&type=script&lang=js"
import style0 from "./imPopup.vue?vue&type=style&index=0&id=1a6830ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6830ea",
  null
  
)

export default component.exports